import { render } from "./GrowthCard.vue?vue&type=template&id=486c23aa&scoped=true"
import script from "./GrowthCard.vue?vue&type=script&lang=js"
export * from "./GrowthCard.vue?vue&type=script&lang=js"

import "./GrowthCard.vue?vue&type=style&index=0&id=486c23aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486c23aa"]])

export default __exports__